/* eslint-disable camelcase */
import { useObserver } from 'mobx-react-lite';

import type { Dispensaries_Integrations, Maybe } from 'src/gql/graphql';
import { isLeaflogixIntegrationEnabled } from 'utils/dispensary-integrations';
import useDispensary from 'src/dispensary/hooks/use-dispensary';
import useCart from './use-cart';

export const useIsFullstackDispensary = (): boolean => {
  const Cart = useCart();
  const menuType = useObserver(() => Cart.menuType);
  const { dispensary } = useDispensary();
  const leaflogixIntegration = dispensary?.consumerDispensaryIntegrations?.leaflogix as Maybe<
    Array<Maybe<Dispensaries_Integrations>>
  >;
  return isLeaflogixIntegrationEnabled(menuType, leaflogixIntegration);
};
